export default function CSyntax() {
  return <h2>C Syntax</h2>;
}
